import(/* webpackMode: "eager" */ "/app/apps/portal-play/src/app/(app)/games/[gid]/loading.tsx")